export default __webpack_public_path__ + "static/media/roboto-v20-latin-regular.49ae34d4.woff";